module.exports = __webpack_public_path__ + "img/whitecarrotdown.0459a04d.svg";